import { NgModule } from '@angular/core';

import { ActiveOrSelectedItemsPipe } from './_pipes/active-or-selected-items.pipe';
import { DecimalByTwoPipe } from './_pipes/decimal-by-two.pipe';
import { EnumToArrayPipe } from './_pipes/enum-to-array.pipe';
import { GreaterEqualToMaxTimePipe } from './_pipes/greater-equal-to-max-time.pipe';
import { MomentDatePipe } from './_pipes/moment-format.pipe';
import { MomentMathPipe } from './_pipes/moment-math.pipe';
import { NoTimezoneDatePipe } from './_pipes/no-timezone-date.pipe';
import { PersonEmailPipe } from './_pipes/person-email.pipe';
import { PersonPhonePipe } from './_pipes/person-phone.pipe';
import { FullNamePipe } from './_pipes/full-name.pipe';
import { PhoneNumberPipe } from './_pipes/phone-number.pipe';
import { PostScheduledFlightUrlPipe } from './_pipes/post-scheduled-flight-url.pipe';
import { PropertyInObjectPipe } from './_pipes/property-in-object.pipe';
import { RgbColorPipe } from './_pipes/rgb-color.pipe';
import { ShowSchedulePostflightLinkPipe } from './_pipes/show-schedule-postflight-link.pipe';
import { WholeNumberPipe } from './_pipes/whole-number.pipe';
import { UniqByPipe } from './_pipes/uniq-by.pipe';
import { AppSaveEnabledStatePipe } from './_pipes/app-save-enabled-state.pipe';
import { RadioFrequencyDisplayPipe } from './_pipes/radio-frequency-diplay.pipe';
import { ExpiredOrUnExpiredItemsPipe } from './_pipes/expired-unexpired-items.pipe';
import { RgbColorContrastPipe } from './_pipes/rgb-color-contrast.pipe';
import { AircraftEventCrewOrStaffFilterPipe } from './_pipes/event-aircraft-crew-staff-filter.pipe';
import { AircraftEventIcalRecipientFilterPipe } from './_pipes/event-aircraft-ical-recipient-filter.pipe';

@NgModule({
  declarations: [
    ActiveOrSelectedItemsPipe,
    DecimalByTwoPipe,
    EnumToArrayPipe,
    GreaterEqualToMaxTimePipe,
    MomentDatePipe,
    MomentMathPipe,
    NoTimezoneDatePipe,
    PersonEmailPipe,
    PersonPhonePipe,
    PhoneNumberPipe,
    PostScheduledFlightUrlPipe,
    PropertyInObjectPipe,
    RgbColorPipe,
    ShowSchedulePostflightLinkPipe,
    WholeNumberPipe,
    UniqByPipe,
    AppSaveEnabledStatePipe,
    RadioFrequencyDisplayPipe,
    ExpiredOrUnExpiredItemsPipe,
    RgbColorContrastPipe,
    AircraftEventCrewOrStaffFilterPipe,
    AircraftEventIcalRecipientFilterPipe,
    FullNamePipe
  ],
  exports: [
    ActiveOrSelectedItemsPipe,
    DecimalByTwoPipe,
    EnumToArrayPipe,
    GreaterEqualToMaxTimePipe,
    MomentDatePipe,
    MomentMathPipe,
    NoTimezoneDatePipe,
    PersonEmailPipe,
    PersonPhonePipe,
    PhoneNumberPipe,
    PostScheduledFlightUrlPipe,
    PropertyInObjectPipe,
    RgbColorPipe,
    ShowSchedulePostflightLinkPipe,
    WholeNumberPipe,
    UniqByPipe,
    AppSaveEnabledStatePipe,
    RadioFrequencyDisplayPipe,
    ExpiredOrUnExpiredItemsPipe,
    RgbColorContrastPipe,
    AircraftEventCrewOrStaffFilterPipe,
    AircraftEventIcalRecipientFilterPipe,
    FullNamePipe
  ]
})
export class SharedPipesModule {}
